import React, { useState, useRef, useEffect } from "react";
import "./ContextMenu.css";

const ContextMenu = ({
  divisionIdForHtml,
  divisionName,
  onRename,
  onIdChange,
  onDelete,
  onMakeReusable,
  onClose,
  LayOut,
  isReusable,
}) => {
  const [newName, setNewName] = useState("");
  const [newId, setNewId] = useState("");
  const [error, setError] = useState("");
  const [errorID, setErrorID] = useState("");
  const inputRef = useRef(null);
  const idInputRef = useRef(null);
  const contextMenuRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }

    const handleClickOutside = (event) => {
      if (
        contextMenuRef.current &&
        !contextMenuRef.current.contains(event.target)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const validateName = (name) => {
    const regex = /^[a-zA-Z][a-zA-Z0-9_]*$/;
    return name === "" || regex.test(name);
  };

  const handleRename = () => {
    if (validateName(newName)) {
      onRename(newName);
      onClose();
    } else {
      setError(
        "Invalid name. It must start with a letter and only contain letters, numbers, and underscores. No spaces."
      );
    }
  };

  const handleIdChange = () => {
    if (validateName(newId)) {
      onIdChange(newId);
      onClose();
    } else {
      setErrorID(
        "Invalid Id. Only letters, numbers, and underscores are allowed. No spaces."
      );
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (document.activeElement === inputRef.current) {
        handleRename();
      } else if (document.activeElement === idInputRef.current) {
        handleIdChange();
      }
    } else if (e.key === "Escape") {
      handleClose();
    }
  };

  const handleClose = () => {
    if (validateName(newName)) {
      onClose();
    } else {
      setError("Error refresh The Page Please!!");
    }
  };

  const ClassForContextMenu =
    LayOut === 1 || LayOut === 2
      ? "context-menuOne"
      : LayOut === 3
      ? "context-menuThree"
      : "context-menu";

  return (
    <div ref={contextMenuRef} className={ClassForContextMenu}>
      <button id="close-button" onClick={handleClose}>
        &times;
      </button>
      <div className="input-group">
        <input
          ref={inputRef}
          type="text"
          value={newName}
          onChange={(e) => {
            setNewName(e.target.value);
            setError("");
          }}
          onKeyDown={handleKeyDown}
          placeholder={
            divisionName ? `Update "${divisionName}"` : `${divisionName}`
          }
        />
        <button onClick={handleRename}>Rename</button>
        {error && <p className="error">{error}</p>}
      </div>
      {!isReusable && (
        <div className="input-group">
          <input
            ref={idInputRef}
            type="text"
            value={newId}
            onChange={(e) => {
              setNewId(e.target.value);
              setErrorID("");
            }}
            onKeyDown={handleKeyDown}
            placeholder={
              divisionIdForHtml ? `Id= "${divisionIdForHtml}"` : "Set Id"
            }
          />
          <button onClick={handleIdChange}>Set Id</button>
          {errorID && <p className="error">{errorID}</p>}
        </div>
      )}
      <div className="button-container">
        <button className="delete-button" onClick={onDelete}>
          Delete
        </button>
        {isReusable && (
          <button className="make-reusable-button" onClick={onMakeReusable}>
            Apply Component
          </button>
        )}
        {!isReusable && (
          <button className="make-reusable-button" onClick={onMakeReusable}>
            Make Component
          </button>
        )}
      </div>
    </div>
  );
};

export default ContextMenu;
